import { Component, inject, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { PlatformConfigService } from '../../services/platform-config.service';

import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-connection-overlay',
  standalone: true,
  imports: [CommonModule, SpinnerComponent, TranslatePipe],
  templateUrl: './connection-overlay.component.html',
  styleUrl: './connection-overlay.component.css',
})
export class ConnectionOverlayComponent {
  private platformConfigService = inject(PlatformConfigService);

  isVisible = input<boolean>(false);
  isReconnecting = input<boolean>(false);

  currentConfig = this.platformConfigService.currentConfig;
  allConfigs = computed(() => this.platformConfigService.getAllPlatforms());
}
